type Props = {
  numberOfItems: number;
};

const items = (numberOfItems: number) => {
  const rows = [];
  let delay = 0;
  for (let i = 0; i < numberOfItems; i += 1) {
    rows.push(
      <div
        key={i}
        className="h-10 bg-gray-100 rounded animate-pulse"
        style={{
          animationFillMode: "backwards",
          animationDelay: `${(delay += 150)}ms`,
        }}
      >
        {" "}
      </div>
    );
  }

  return rows;
};

const VehicleFiltersSkeleton = ({ numberOfItems }: Props) => {
  return (
    <div className="px-4 w-full xs:mt-5">
      <div className="grid grid-flow-row gap-y-5 [&>div:nth-child(1)]:h-6 [&>div:nth-child(1)]:w-32 [&>div:nth-child(2)]:h-20">
        {items(numberOfItems)}
      </div>
    </div>
  );
};

export default VehicleFiltersSkeleton;
